export const initializePollfishConfig = () => {
    const pollfishConfig = {
        api_key: import.meta.env.VITE_APP_POLLFISH_WALL_CODE,
        user_id: "",
        placement_key: import.meta.env.VITE_APP_POLLFISH_PLACEMENT_KEY,
        indicator_position: "BOTTOM_RIGHT",
        debug: true,
        offerwall: true,
        ready: onOfferwallReady,
        surveyNotAvailable: onSurveyNotAvailable,
        surveyCompletedCallback: onSurveyCompleted,
        userNotEligibleCallback: onUserDisqualified,
    };

    // @ts-expect-error Pollfish is loaded from external script
    window.pollfishConfig = pollfishConfig;
};

function onOfferwallReady(data: unknown) {
    // console.log("Offerwall is ready", data);
}

function onSurveyNotAvailable(data: unknown) {
    console.log("Survey is not available", data);
}

function onSurveyCompleted(data: unknown) {
    console.log("Survey is completed", data);
}

function onUserDisqualified(data: unknown) {
    console.log("User is disqualified", data);
} 